module.exports = __webpack_public_path__ + "static/media/MATSON.df391cfd.svg";